import { render, staticRenderFns } from "./MoverCategories.vue?vue&type=template&id=f0274d60&"
import script from "./MoverCategories.vue?vue&type=script&lang=js&"
export * from "./MoverCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports